<template>
  <div>
    <div>{{$t('LBL_DOCUMENT_WAS_SIGNED')}}</div>
    <div>{{$t('LBL_ONLINE')}}</div>
    <div>
      {{$t('LBL_ON')}} {{formattedEsignedDate}}
    </div>
    <div v-if="fullName.length">
      {{$t('LBL_BY')}} {{fullName}}
    </div>
    <div v-if="hasPhone">
      <div>{{$t('LBL_USING_THE_PHONE')}}</div>
      <div>
        {{this.esignInfo.signatory.cellPhone}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    esignInfo: {
      type: Object,
      default: () => ({
        signedDate: '',
        signatory: {
          firstName: '',
          lastName: '',
          cellPhone: ''
        }
      })
    }
  },
  computed: {
    formattedEsignedDate() {
      return this.esignInfo.signedDate ? this.getLocalDate(this.esignInfo.signedDate) : '';
    },

    fullName() {
      if (!this.esignInfo.signatory) {
        return '';
      }
      const { firstName, lastName } = this.esignInfo.signatory;
      return [firstName, lastName].filter(Boolean).join(' ');
    },

    hasPhone() {
      try {
        return this.esignInfo.signatory.cellPhone.trim().length > 0;
      } catch {
        return false;
      }
    }
  }
}
</script><style lang="scss">@import "@/assets/scss/components/Esign/_esigninfo.scss";</style>